module.exports = __webpack_public_path__ + "static/media/greenbg.4089f632.png";